"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SendWebPushDto = void 0;
class SendWebPushDto {
    userIds;
    payload;
}
exports.SendWebPushDto = SendWebPushDto;
